import { CSSProperties, useMemo } from "react";
import { classNames } from "primereact/utils";
import styles from "./DesignStudioEmailPreview.module.scss";
import { IDesignStudioColors } from "../models/designStudioPresetModel";
import { resolveEmailHeaderPalette } from "../utils/emailHeaderPaletteUtility";
import {
  Default_Button_Background_Color,
  Default_Button_Text_Color,
  isValidHexColor,
} from "../../../../../../common/infrastructure/utilities/colorUtility";

interface IDesignStudioEmailPreviewProps {
  colors: IDesignStudioColors;
  studioName?: string;
  className?: string;
}

const DETAILS = [
  { label: "Услуга", value: "Масаж, 60 мин" },
  { label: "Кога", value: "сряда, 21 октомври · 10:00" },
  { label: "При", value: "Мария Петрова" },
];

const hex = (value: string, fallback: string) =>
  `#${isValidHexColor(value) ? value.trim().replace(/^#/, "") : fallback}`;

/** The client's confirmation e-mail, its header painted exactly as the backend will. */
export const DesignStudioEmailPreview = ({
  colors,
  studioName,
  className,
}: IDesignStudioEmailPreviewProps) => {
  const style = useMemo(() => {
    const header = resolveEmailHeaderPalette(
      colors.backgroundColorPrimary,
      colors.backgroundColorSecondary,
    );

    return {
      "--ds-email-from": header.gradientFrom,
      "--ds-email-to": header.gradientTo,
      "--ds-email-text": header.textColor,
      "--ds-email-badge-bg": header.pillBackground,
      "--ds-email-badge-border": header.pillBorder,
      "--ds-email-button-bg": hex(colors.buttonBackgroundColor, Default_Button_Background_Color),
      "--ds-email-button-text": hex(colors.buttonTextColor, Default_Button_Text_Color),
    } as CSSProperties;
  }, [
    colors.backgroundColorPrimary,
    colors.backgroundColorSecondary,
    colors.buttonBackgroundColor,
    colors.buttonTextColor,
  ]);

  return (
    <div
      className={classNames(styles.root, className)}
      style={style}
      role="img"
      aria-label="Преглед на имейла до клиента"
      data-testid="design-studio-email-preview"
    >
      <div className={styles.sheet}>
        <div className={styles.hero}>
          <span className={styles.hero_badge}>Резервацията е потвърдена</span>
          <span className={styles.hero_name}>{studioName?.trim() || "Вашето студио"}</span>
        </div>

        <div className={styles.body}>
          <span className={styles.body_title}>Потвърдена резервация</span>
          <span className={styles.body_text}>Вашият час е успешно запазен. Очакваме Ви!</span>
        </div>

        <div className={styles.details}>
          {DETAILS.map((row) => (
            <span key={row.label} className={styles.details_row}>
              <span className={styles.details_label}>{row.label}</span>
              <span className={styles.details_value}>{row.value}</span>
            </span>
          ))}
        </div>

        <div className={styles.actions}>
          <span className={styles.actions_button}>Плати онлайн</span>
        </div>
      </div>
    </div>
  );
};
